var map = {
	"./crypto_duck_1.png": 3584,
	"./crypto_duck_10.png": 3371,
	"./crypto_duck_100.png": 8842,
	"./crypto_duck_101.png": 7874,
	"./crypto_duck_102.png": 7199,
	"./crypto_duck_103.png": 4886,
	"./crypto_duck_104.png": 5968,
	"./crypto_duck_105.png": 1412,
	"./crypto_duck_106.png": 4551,
	"./crypto_duck_107.png": 2643,
	"./crypto_duck_108.png": 9241,
	"./crypto_duck_109.png": 997,
	"./crypto_duck_11.png": 673,
	"./crypto_duck_110.png": 1621,
	"./crypto_duck_111.png": 3638,
	"./crypto_duck_112.png": 6099,
	"./crypto_duck_113.png": 5873,
	"./crypto_duck_114.png": 5624,
	"./crypto_duck_115.png": 1939,
	"./crypto_duck_116.png": 722,
	"./crypto_duck_117.png": 1978,
	"./crypto_duck_118.png": 8755,
	"./crypto_duck_119.png": 4696,
	"./crypto_duck_12.png": 5947,
	"./crypto_duck_120.png": 5988,
	"./crypto_duck_121.png": 3007,
	"./crypto_duck_122.png": 5735,
	"./crypto_duck_123.png": 4078,
	"./crypto_duck_124.png": 5092,
	"./crypto_duck_125.png": 3538,
	"./crypto_duck_126.png": 7264,
	"./crypto_duck_127.png": 2464,
	"./crypto_duck_128.png": 2578,
	"./crypto_duck_129.png": 5263,
	"./crypto_duck_13.png": 8127,
	"./crypto_duck_130.png": 7568,
	"./crypto_duck_131.png": 864,
	"./crypto_duck_132.png": 4336,
	"./crypto_duck_133.png": 5805,
	"./crypto_duck_134.png": 5854,
	"./crypto_duck_135.png": 5021,
	"./crypto_duck_136.png": 4304,
	"./crypto_duck_137.png": 242,
	"./crypto_duck_138.png": 3800,
	"./crypto_duck_139.png": 5213,
	"./crypto_duck_14.png": 5466,
	"./crypto_duck_140.png": 2049,
	"./crypto_duck_141.png": 8858,
	"./crypto_duck_142.png": 6310,
	"./crypto_duck_143.png": 8427,
	"./crypto_duck_144.png": 3836,
	"./crypto_duck_145.png": 8691,
	"./crypto_duck_146.png": 9297,
	"./crypto_duck_147.png": 7165,
	"./crypto_duck_148.png": 123,
	"./crypto_duck_149.png": 7633,
	"./crypto_duck_15.png": 952,
	"./crypto_duck_150.png": 4741,
	"./crypto_duck_151.png": 1497,
	"./crypto_duck_152.png": 2720,
	"./crypto_duck_153.png": 7281,
	"./crypto_duck_154.png": 4402,
	"./crypto_duck_155.png": 7033,
	"./crypto_duck_156.png": 4467,
	"./crypto_duck_157.png": 9879,
	"./crypto_duck_158.png": 833,
	"./crypto_duck_159.png": 7860,
	"./crypto_duck_16.png": 8274,
	"./crypto_duck_160.png": 8859,
	"./crypto_duck_161.png": 1835,
	"./crypto_duck_162.png": 7447,
	"./crypto_duck_163.png": 3472,
	"./crypto_duck_164.png": 6456,
	"./crypto_duck_165.png": 7349,
	"./crypto_duck_166.png": 6470,
	"./crypto_duck_167.png": 9583,
	"./crypto_duck_168.png": 461,
	"./crypto_duck_169.png": 374,
	"./crypto_duck_17.png": 3542,
	"./crypto_duck_170.png": 9896,
	"./crypto_duck_171.png": 3460,
	"./crypto_duck_172.png": 2492,
	"./crypto_duck_173.png": 5710,
	"./crypto_duck_174.png": 1172,
	"./crypto_duck_175.png": 4394,
	"./crypto_duck_176.png": 8115,
	"./crypto_duck_177.png": 3626,
	"./crypto_duck_178.png": 4281,
	"./crypto_duck_179.png": 1161,
	"./crypto_duck_18.png": 7695,
	"./crypto_duck_180.png": 9954,
	"./crypto_duck_181.png": 4316,
	"./crypto_duck_182.png": 2380,
	"./crypto_duck_183.png": 6599,
	"./crypto_duck_184.png": 2178,
	"./crypto_duck_185.png": 5026,
	"./crypto_duck_186.png": 705,
	"./crypto_duck_187.png": 8757,
	"./crypto_duck_188.png": 890,
	"./crypto_duck_189.png": 5436,
	"./crypto_duck_19.png": 1067,
	"./crypto_duck_190.png": 2745,
	"./crypto_duck_191.png": 6010,
	"./crypto_duck_192.png": 7136,
	"./crypto_duck_193.png": 7804,
	"./crypto_duck_194.png": 3368,
	"./crypto_duck_195.png": 2993,
	"./crypto_duck_196.png": 9321,
	"./crypto_duck_197.png": 5985,
	"./crypto_duck_198.png": 507,
	"./crypto_duck_199.png": 3033,
	"./crypto_duck_2.png": 1128,
	"./crypto_duck_20.png": 8452,
	"./crypto_duck_200.png": 2749,
	"./crypto_duck_21.png": 3970,
	"./crypto_duck_22.png": 1220,
	"./crypto_duck_23.png": 7336,
	"./crypto_duck_24.png": 9299,
	"./crypto_duck_25.png": 4668,
	"./crypto_duck_26.png": 7147,
	"./crypto_duck_27.png": 7688,
	"./crypto_duck_28.png": 6684,
	"./crypto_duck_29.png": 8071,
	"./crypto_duck_3.png": 6354,
	"./crypto_duck_30.png": 7978,
	"./crypto_duck_31.png": 8135,
	"./crypto_duck_32.png": 3241,
	"./crypto_duck_33.png": 6976,
	"./crypto_duck_34.png": 2677,
	"./crypto_duck_35.png": 8536,
	"./crypto_duck_36.png": 6209,
	"./crypto_duck_37.png": 1176,
	"./crypto_duck_38.png": 3148,
	"./crypto_duck_39.png": 8541,
	"./crypto_duck_4.png": 7561,
	"./crypto_duck_40.png": 3272,
	"./crypto_duck_41.png": 3358,
	"./crypto_duck_42.png": 9041,
	"./crypto_duck_43.png": 46,
	"./crypto_duck_44.png": 3019,
	"./crypto_duck_45.png": 5413,
	"./crypto_duck_46.png": 1544,
	"./crypto_duck_47.png": 2306,
	"./crypto_duck_48.png": 822,
	"./crypto_duck_49.png": 7947,
	"./crypto_duck_5.png": 9013,
	"./crypto_duck_50.png": 1040,
	"./crypto_duck_51.png": 2636,
	"./crypto_duck_52.png": 2323,
	"./crypto_duck_53.png": 1279,
	"./crypto_duck_54.png": 4757,
	"./crypto_duck_55.png": 4468,
	"./crypto_duck_56.png": 4681,
	"./crypto_duck_57.png": 8120,
	"./crypto_duck_58.png": 4221,
	"./crypto_duck_59.png": 1372,
	"./crypto_duck_6.png": 2091,
	"./crypto_duck_60.png": 8225,
	"./crypto_duck_61.png": 1555,
	"./crypto_duck_62.png": 2934,
	"./crypto_duck_63.png": 431,
	"./crypto_duck_64.png": 552,
	"./crypto_duck_65.png": 7339,
	"./crypto_duck_66.png": 4742,
	"./crypto_duck_67.png": 7084,
	"./crypto_duck_68.png": 7673,
	"./crypto_duck_69.png": 8950,
	"./crypto_duck_7.png": 3269,
	"./crypto_duck_70.png": 8069,
	"./crypto_duck_71.png": 2821,
	"./crypto_duck_72.png": 488,
	"./crypto_duck_73.png": 9152,
	"./crypto_duck_74.png": 8529,
	"./crypto_duck_75.png": 6820,
	"./crypto_duck_76.png": 7620,
	"./crypto_duck_77.png": 9655,
	"./crypto_duck_78.png": 5240,
	"./crypto_duck_79.png": 5512,
	"./crypto_duck_8.png": 6079,
	"./crypto_duck_80.png": 5292,
	"./crypto_duck_81.png": 7277,
	"./crypto_duck_82.png": 9805,
	"./crypto_duck_83.png": 3619,
	"./crypto_duck_84.png": 9572,
	"./crypto_duck_85.png": 898,
	"./crypto_duck_86.png": 229,
	"./crypto_duck_87.png": 5101,
	"./crypto_duck_88.png": 2027,
	"./crypto_duck_89.png": 5760,
	"./crypto_duck_9.png": 6080,
	"./crypto_duck_90.png": 9924,
	"./crypto_duck_91.png": 4514,
	"./crypto_duck_92.png": 6336,
	"./crypto_duck_93.png": 5349,
	"./crypto_duck_94.png": 3048,
	"./crypto_duck_95.png": 6241,
	"./crypto_duck_96.png": 381,
	"./crypto_duck_97.png": 2199,
	"./crypto_duck_98.png": 9703,
	"./crypto_duck_99.png": 7830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2320;